export default __webpack_public_path__ + "static/media/robot.42992d64.svg";